import * as S from "./SystemSection.style";
import { Legend } from "../../molecules/Legends";
import { SystemEquipBoard } from "../../molecules/SystemEquipBoard";
import {
  EquipmentOperationStatus,
  EquipmentOperationStatusLED,
} from "../../../common/types/equipment";

interface SystemSectionProps {
  shipType: "1000" | "3000" | string;
  equipmentOperationStatus: EquipmentOperationStatus;
  equipmentOperationStatusLED?: EquipmentOperationStatusLED;
  navigateToPath: (path?: string) => void;
  onContextMenu: (event: React.MouseEvent, target: any) => void;
}
export const SystemSection = ({
  shipType,
  equipmentOperationStatus,
  equipmentOperationStatusLED,
  navigateToPath,
  onContextMenu,
}: SystemSectionProps) => {
  return (
    <S.SystemSection>
      <S.SystemContent>
        <SystemEquipBoard
          shipType={shipType}
          equipmentOperationStatus={equipmentOperationStatus}
          equipmentOperationStatusLED={equipmentOperationStatusLED}
          navigateToPath={navigateToPath}
          onContextMenu={onContextMenu}
        />
      </S.SystemContent>

      <Legend title="LED" type="led-equip" />
    </S.SystemSection>
  );
};
